import { Component, ElementRef, Input, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { PopupService } from '../services/popup.service';
import { GlobalService } from '../services/global.service';
import { CallmethodService } from '../services/callmethod.service';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DataShareService } from '../services/data-share.service';
import { debounceTime, delay, distinctUntilChanged, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators';
import { of, Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';

@Component({
	selector: 'app-rental-edit',
	templateUrl: './rental-edit.component.html',
	styleUrls: ['./rental-edit.component.scss']
})
export class RentalEditComponent implements OnInit, OnDestroy {
	isRentalEnabledEditBooking: boolean = false;
	editJobAddressList: any = [];
	currency: any = null;
	environment: any = environment;
	editJobCouponLoader: boolean = true;
	isAccountUser: boolean = false;
	dateFormat: string = 'YYYY/MM/DD';
	isActiveBooking: boolean = false;
	nearestDriverList: any = [];
	onlineDriverList: any[] = [];
	packagesArray: any[] = []

	private subscriptionShareData: Subscription = new Subscription;
	private subscriptionSearchAutoComplete1: Subscription = new Subscription;
	private subscription: Subscription = new Subscription;

	editRentalBookingForm: FormGroup = new FormGroup({});
	private unsubscribe$ = new Subject<void>();

	constructor(
		public Global: GlobalService,
		public Popup: PopupService,
		public CallMethod: CallmethodService,
		public Router: Router,
		private formBuilder: FormBuilder,
		public shareData: DataShareService
	) {
		this.editRentalBookingForm = new FormGroup({
			pickupPoint: new FormControl(''),
			editJobUserComment: new FormControl(''),
			editJobDriverComment: new FormControl(''),
			editRideSelectedHours: new FormControl(''),
			editRideSelectedMinute: new FormControl(''),
			editBookingCalenderModel: new FormControl(''),
			editRideSelectedAssignTime: new FormControl(''),
			accountId: new FormControl(''),
			id: new FormControl(''),
			name: new FormControl(''),
			phone: new FormControl(''),
			emailAddress: new FormControl(''),
			editRideSetDriverId: new FormControl(''),
			editBookingCouponCode: new FormControl({}),
			editJobFlightNo: new FormControl(''),
			editJobRoomNo: new FormControl('')
		});

	}

	ngOnInit(): void {
		this.subscriptionShareData = this.shareData.getData().subscribe(data => {
			if (data) {
				console.log("data Share  :::::::::::::::::::::::: from rental component", data);
				if (data.function == 'EnableRentalEditForm') {
					this.isRentalEnabledEditBooking = true;
				}
				if (data.function == 'SetRentalEditBookingDetails' && data.data) {
					console.log('---- Edit Rental set details ----', data.data);

					this.isActiveBooking = false;
					if (data.tab == 'active') {
						this.isActiveBooking = true
					}
					if (data.online) {
						this.onlineDriverList = data.online
					}
					if (data.nearest) {
						this.nearestDriverList = data.nearest
					}

					this.setEditBookingDetails(data.data);
					this.selectedBooking = data.data;
					console.log('---+++ this.isActiveBooking ---+++', this.isActiveBooking)
				}

				if (data.function == 'setUserDetails' && this.isRentalEnabledEditBooking) {
					console.log('rental edit set user details', data.data)
					this.setUserDetails(data.data)
				}

				if (data.function == 'RentalSelectCarFunctionCall') {
					if (data.callType == 'cancel') {
						this.onCancelClick()
					}

					if (data.callType == 'select' && data.carData) {
						this.selectAccountCar(data.carData)
					}

					if (data.callType == 'edit') {
						this.editRentalBooking()
					}
				}

				if (data.function == 'EditBookingFunctionCalled') {
					this.editRentalBooking()
				}
				if (data.function == 'dragMarkerForPickup' && data.locations) {
					console.log('rental pickup marker dragged -------', data.locations, data.event)
					this.setDragMarkerLocation(data.event, data.locations)
				}
			}
		});

		this.subscriptionSearchAutoComplete1 = this.searchAutoComplete.pipe(
			map((event: any) => event.target.value),
			debounceTime(300),
			distinctUntilChanged(),
			switchMap((search: string) => of(search))
		).subscribe((data: any) => {
			this.getAutoSearch(data);
		});

		this.subscription = this.searchCorporateAccount.pipe(
			map((event: any) => event.target.value),
			debounceTime(300),
			distinctUntilChanged(),
			mergeMap((search: any) => of(search).pipe(delay(0))),
		).subscribe((data: any) => {
			this.newRideAccountIdCall(data);
		});
	}

	ngOnDestroy(): void {
		this.subscriptionSearchAutoComplete1.unsubscribe()
		this.searchAutoComplete.unsubscribe()
		this.subscriptionShareData.unsubscribe()
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		this.unsubscribe$.unsubscribe()
	}

	enabledEditBooking() {
		this.isRentalEnabledEditBooking = true;
	}

	editRentalBooking() {
		this.Global.rentalEditJobLoader = false;
		if (this.selectedBooking.bookingId != undefined && this.selectedBooking.bookingId.trim() != ''
			&& Array.isArray(this.editLocationJson) && this.editLocationJson.length > 0
			&& this.editJobSelectedCarTypeData.data.baseFare != undefined
			&& this.editJobSelectedCarTypeData.data.carTypeId != undefined
		) {
			if (
				this.editRentalBookingForm.value.id.trim() != ''
				&& (this.editRentalBookingForm.value.accountId.trim() == '' || this.editRentalBookingForm.value.accountId == null)
				&& this.editRentalBookingForm.value.emailAddress.trim() == ''
				&& this.editRentalBookingForm.value.phone.trim() == ''
			) {
				this.editRentalBookingForm.value.id = '';
			}


			let userJson = [{
				accountId: this.editRentalBookingForm.value.accountId,
				passengerId: this.editRentalBookingForm.value.id,
				passengerName: this.editRentalBookingForm.value.name,
				passengerEmail: this.editRentalBookingForm.value.emailAddress.trim(),
				passengerPhone: this.editRentalBookingForm.value.phone.trim(), //! vishesh 30-01-24
			}];

			const request: any = {
				bookingId: this.selectedBooking.bookingId,
				driverId: this.editRentalBookingForm.value.editRideSetDriverId,
				bookingType: 0,
				isDevice: environment.device,
				baseFare: this.editJobSelectedCarTypeData.data.baseFare,
				isDispatcher: true,
				paymentType: this.selectedPaymentType,
				carRent: parseFloat("" + this.editJobCarRent).toFixed(environment.priceRoundUpNumber),
				distanceVariant: this.editJobDistanceVariant,
				userJson: userJson,
				bookingFlag: 1,
				location: this.editLocationJson,
				userComment: this.editRentalBookingForm.value.editJobUserComment,
				driverComment: this.editRentalBookingForm.value.editJobDriverComment,
				carDetails: this.selectedCarDetails,
				userId: this.editRentalBookingForm.value.id
			};

			if (this.editRentalBookingForm.value.accountId && this.editRentalBookingForm.value.accountId.trim() != '') {
				request['accountId'] = this.editRentalBookingForm.value.accountId;
				request['paymentType'] = 2;
			}

			if (userJson[0].accountId == "" && this.selectedPaymentType == 2) {
				request['paymentType'] = 0;
			}

			if (this.editCarTypeId) {
				request['carTypeId'] = this.editCarTypeId
			}

			if (this.editCarTypeName) {
				request['carType'] = this.editCarTypeName
			}

			if (this.editJobZoneId) {
				request['zoneId'] = this.editJobZoneId
			}

			request['flightNo'] = this.editRentalBookingForm.value.editJobFlightNo
			request['roomNo'] = this.editRentalBookingForm.value.editJobRoomNo
			request['couponCode'] = this.editRentalBookingForm.value.editBookingCouponCode.couponCode;

			if (!this.editRideOptionStatus) {
				// if(moment(this.Global.getCompanyCurrentTime(), this.Global.dateFormat).format("YYYY-MM-DD HH:mm:ss") > this.editPickupTime ) {
				// 	this.Global.rentalEditJobLoader = true;
				// 	return this.Popup.toasterMessage({
				// 		'status': 'error',
				// 		'title': 'Error',
				// 		'message': 'Please select correct time for later booking.',
				// 	});
				// }
				request['pickupTime'] = this.editPickupTime;
				request['bookingType'] = 1;
				request['assignMinute'] = parseInt(this.editRentalBookingForm.value.editRideSelectedAssignTime);
			}

			if (this.editRideOptionStatus) {
				request['pickupTime'] = moment(this.Global.getCompanyCurrentTime(), this.Global.dateFormat).format("YYYY-MM-DD HH:mm:ss");
				request['bookingType'] = 0;
			}

			if (this.editRentalPackage) {
				request['packageId'] = this.editRentalPackage
			}

			if (this.selectedPackageInfo) {
				request['carDetails'].packagesInfo = this.selectedPackageInfo
			}

			console.log('****** Edit booking request ******', request);
			this.CallMethod.editRentalBookingCall(request).subscribe((res: any) => {
				if (res.status == true) {
					this.Global.rentalEditJobLoader = true;
					this.selectedBooking = {};
					this.nearestDriverList = [];
					this.clearEditBooking();
					this.Popup.toasterMessage({
						'status': 'success',
						'title': 'Success',
						'message': 'Successfully Edit Booking.',
					});
					this.Global.roleJson.cancel_booking['delete'] == 0
					this.shareData.shareData({ 'function': 'RentalBookingEdited' });
				}
				else if (res.statusCode == 1) {
					this.Global.rentalEditJobLoader = true;
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'Error',
						'message': 'Booking not found.',
					});
				}

				else if (res.statusCode == 101) {
					this.Global.rentalEditJobLoader = true;
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'Error',
						'message': 'AccountId is InValid',
					});
				}
				else if (res.statusCode == 102) {
					this.Global.rentalEditJobLoader = true;
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'Error',
						'message': 'Corporate Is Inactive Or Currently unavailable',
					});
				}

				else if (res.statusCode == 3) {
					this.Global.rentalEditJobLoader = true;
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'Error',
						'message': 'booking is Active. So, you can not change time or (type) of this booking.',
					});
				}

				else if (res.statusCode == 4) {
					this.Global.rentalEditJobLoader = true;
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'Error',
						'message': 'Only payment is pending. So, you can not edit this booking.',
					});
				}

				else if (res.statusCode == 5) {
					this.Global.rentalEditJobLoader = true;
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'Error',
						'message': 'Invalid account id.',
					});
				}
				else if (res.statusCode == 6) {
					this.Global.rentalEditJobLoader = true;
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'Error',
						'message': 'booking is Active. So, you can not change time or (type) of this booking.',
					});
				}

				else if (res.statusCode == 10) {
					this.Global.rentalEditJobLoader = true;
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'invalid coupon code',
						'message': 'Please enter correct coupon code.',
					});
				}

				else if (res.statusCode == 7) {
					console.log('got status code 20 -----', this.selectedPassengerId)
					this.Global.rentalEditJobLoader = true;
					let req = {}
					if (res.statusCode == 7) {
						req = {
							"userId": res.userInfo.passengerId,
							"packageId": this.editRentalPackage,
						}
						this.selectedPassengerId = res.userInfo.passengerId;
					}

					console.log('******* Going to call getRentalCarsPackage ******')
					this.CallMethod.getRentalPackageCars(req).subscribe((result: any) => {
						this.showRentShimmer = false;
						if (!result.status && result.statusCode == 1) {
							console.log('****** result from select package *******', result)
							this.Popup.toasterMessage({
								'status': 'error',
								'title': 'incorrect package',
								'message': 'This package is not available for current carType.',
							});
							this.Global.isRentalSubmit = true
						}
						else if (result.status) {
							console.log('___++++___', result)
							this.editCarTypeRentArray = []
							this.isAccountUser = true;
							const dayNight: string = this.Global.getDayNight(this.editPickupTime);
							for (let i = 0; i < result.rentalCars.length; i++) {
								this.editJobCarTypeArray["DAY"] = result.rentalCars[i].rentalCarDayBaseFare;
								this.editJobCarTypeArray["NIGHT"] = result.rentalCars[i].rentalCarNightBaseFare;
								result.rentalCars[i].carRent = this.editJobCarTypeArray[dayNight];
								result.rentalCars[i].baseFare = this.editJobCarTypeArray[dayNight];
								this.editCarTypeRentArray[i] = result.rentalCars[i];
							}
							console.log('^^^^^^^^^^^^', this.editCarTypeRentArray);
							console.log('^^^^^^^^^ selectedpackageinfo', this.selectedPackageInfo);
							console.log('passengerId selected before edit rental cartype open', this.selectedPassengerId)
							this.shareData.shareData({ 'function': 'OpenCarTypeSelectionModel', 'data': this.editCarTypeRentArray });
							this.showRentShimmer = true;
						}
					});
				}
				else {
					console.log('no status code getting...')
					this.Global.rentalEditJobLoader = true;
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'error',
						'message': 'Something went wrong.',
					});
				}
			},
				(error: any) => {
					console.error('API Call Failed:', error);
				}
			)
			console.log('after edit booking api call.')
			return true;
		}
		else {
			this.Global.rentalEditJobLoader = true;
			this.Popup.toasterMessage({
				'status': 'error',
				'title': 'error',
				'message': 'Please pass required parameters.',
			});
			return false;
		}
	}

	createJobAddressList: any = [];
	finAreaJobAddressList: any = [];
	createJobUserAddressList: any = [];
	getAutoSearch(value: string = "") {
		if (this.createJobAddressList.length > 0 && (this.flag == '' || this.flag == 'Redis')) {
			this.createJobAddressList = this.Global.filterByValueObj(this.createJobUserAddressList, "fullAddress", value);
		}
		else {
			const req = {
				"sessionId": this.Global.getSessionId(),
				"flag": this.flag,
				"address": value
			};

			this.CallMethod.getAutoCompleteAddress(req).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
				this.createJobAddressList = [];
				this.editJobAddressList = [];
				this.finAreaJobAddressList = [];
				if (result.status) {
					if (result.data.length > 0) {

						if (this.flag == "" || result.data[0].lat == 0) {
							this.flag = result.data[0].flag;
						}

						for (let i = 0; i < result.data.length; i++) {
							let address = {
								'title': result.data[i].title,
								'address': result.data[i].address,
								'lat': result.data[i].lat,
								'long': result.data[i].long,
								'placeId': result.data[i].placeId,
								'flag': result.data[i].flag
							}

							this.editJobAddressList.push(address);
							this.finAreaJobAddressList.push(address);
						}
					}
				}
			});
		}
	}

	setUserDetails(data: any) {
		this.editRentalBookingForm.get('name')?.setValue(data.userName);
		this.editRentalBookingForm.get('phone')?.setValue(data.userMobile);
		this.editRentalBookingForm.get('emailAddress')?.setValue(data.userEmail);
		this.selectedPassengerId = data.userId;
		console.log('setUserDetails data.userId ', data.userId)
		console.log('setUserDetails this.editRentalBookingForm.value.id ', this.editRentalBookingForm.value.id)
		console.log('setUserDetails data.userIsCorporate ', data.userIsCorporate)

		if (data.userId != this.editRentalBookingForm.value.id && data.userIsCorporate == 1) {
			console.log('******* Going to call getRentalCarsPackage ******')

			let req = {
				"userId": data.userId,
				"packageId": this.editRentalPackage,
			}

			this.editRentalBookingForm.get('id')?.setValue(data.userId);
			this.CallMethod.getRentalPackageCars(req).subscribe((result: any) => {
				this.showRentShimmer = false;
				if (!result.status && result.statusCode == 1) {
					console.log('****** result from select package *******', result)
					this.Popup.toasterMessage({
						'status': 'error',
						'title': 'incorrect package',
						'message': 'This package is not available for current carType.',
					});
					this.Global.isRentalSubmit = true
				}
				else if (result.status) {
					console.log('___++++___', result)
					this.editCarTypeRentArray = []
					this.isAccountUser = true;
					const dayNight: string = this.Global.getDayNight(this.editPickupTime);
					for (let i = 0; i < result.rentalCars.length; i++) {
						this.editJobCarTypeArray["DAY"] = result.rentalCars[i].rentalCarDayBaseFare;
						this.editJobCarTypeArray["NIGHT"] = result.rentalCars[i].rentalCarNightBaseFare;
						result.rentalCars[i].carRent = this.editJobCarTypeArray[dayNight];
						result.rentalCars[i].baseFare = this.editJobCarTypeArray[dayNight];
						this.editCarTypeRentArray[i] = result.rentalCars[i];
					}
					console.log('^^^^^^^^^^^^', this.editCarTypeRentArray);
					console.log('^^^^^^^^^ selectedpackageinfo', this.selectedPackageInfo)
					this.shareData.shareData({ 'function': 'OpenCarTypeSelectionModel', 'data': this.editCarTypeRentArray });
					this.showRentShimmer = true;
				}
			});
		}
		else {
			this.editRentalBookingForm.get('id')?.setValue(data.userId);
		}
	}

	accountDataList: any[] = [];
	editJobAccountDataList: any[] = [];
	newRideAccountIdCall(accountId: any) {
		this.accountDataList = [];
		this.CallMethod.getSearchAccountId({ search: accountId }).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
			this.accountDataList = [];
			this.editJobAccountDataList = [];
			if (result.status) {
				this.editJobAccountDataList = result.data;
			}
		})
	}

	editBookingCalenderModel: any;
	isEditStreetPickup: boolean = false;
	editExtraCharges: any = {};
	selectedPaymentType: number = 0;
	packageHours: any
	selectedCarDetails: any = {}
	selectedPassengerId: string = ''
	selectedAccountId: string = ''
	setEditBookingDetails(bookingData: any) {
		console.log("=-=-=-=-= -SEt Edit  bookingData :: ", bookingData);
		if (
			bookingData.bookingId && bookingData.bookingId.trim() !== '' &&
			bookingData.dBookId && bookingData.dBookId.trim() !== '' &&
			Array.isArray(bookingData.locationJson) &&
			Array.isArray(bookingData.userJson) &&
			bookingData.carRent !== undefined &&
			bookingData.currency !== undefined &&
			bookingData.distanceVariant !== undefined &&
			bookingData.surgeMultiplier !== undefined &&
			bookingData.zoneId !== undefined &&
			bookingData.carTypeId !== undefined &&
			bookingData.carTypeName !== undefined &&
			bookingData.baseFare !== undefined &&
			bookingData.carDetails.carSeatCapacity !== undefined &&
			bookingData.driverId !== undefined &&
			bookingData.roomNo !== undefined &&
			bookingData.userComment !== undefined &&
			bookingData.driverComment !== undefined &&
			bookingData.paymentType != undefined &&
			bookingData.bookingType !== undefined &&
			bookingData.pickupTime !== undefined &&
			bookingData.assignTime !== undefined &&
			bookingData.taxJson !== undefined &&
			bookingData.packageId !== undefined
		) {
			console.log('---- Entered in set Edit Booking Details ----')
			this.editRentalBookingForm.get('editBookingCouponCode')?.reset();
			let requestObj = {
				lat: Number(bookingData.locationJson[0].lat),
				long: Number(bookingData.locationJson[0].long),
				address: bookingData.locationJson[0].address,
			};

			// this.clearEditBooking()
			// this.removeCouponCode();
			console.log("requestObj", requestObj);
			this.packageHours = bookingData.carDetails.packagesInfo.packageHours;
			this.selectedPackageInfo = bookingData.carDetails.packagesInfo;
			this.editRentalPackage = bookingData.packageId;
			this.selectedCarDetails = bookingData.carDetails;
			this.editCarTypeId = bookingData.carTypeId;
			this.editPickupTime = bookingData.pickupTime;
			this.CallMethod.getRentalPackage(requestObj).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
				if (result.status) {
					console.log('data get from get rental packages', result);
					this.packagesArray = result.packagesInfo;
					result.zoneId ? this.editJobZoneId = result.zoneId : null
				}
			});
			this.isRentalEnabledEditBooking = false;
			this.editExtraCharges = bookingData.extraChargesJson;
			if (bookingData.distanceVariant == 'km' || bookingData.distanceVariant == 'miles') {
				bookingData.distanceVariant = (bookingData.distanceVariant == 'km') ? 0 : 1;
			}

			this.selectedPaymentType = bookingData.paymentType;

			bookingData.locationJson[0].addressId = 'pickup';
			this.editRentalBookingForm.get('pickupPoint')?.setValue(bookingData.locationJson[0].address);
			this.editLocationList = bookingData.locationJson;
			this.editLocationJson = bookingData.locationJson;
			this.shareData.shareData({ function: 'SetRentalLocationInMap', 'data': this.editLocationList })


			this.editJobShowRentInfo = true;
			if (Object.entries(bookingData.couponDetails).length !== 0) {
				console.log('entered in set coupon details in form', bookingData.couponDetails)
				this.editRentalBookingForm.get('editBookingCouponCode')?.setValue(bookingData.couponDetails);
			}
			else {
				this.editRentalBookingForm.get('editBookingCouponCode')?.setValue({});
			}

			this.withoutSurgeEditJobCarRent = parseFloat((bookingData.carRent / bookingData.surgeMultiplier).toFixed(environment.priceRoundUpNumber))
			this.editJobCarRent = bookingData.carRent;
			this.editJobCarRent = parseFloat(this.editJobCarRent.toFixed(environment.priceRoundUpNumber))
			this.editJobCurrency = bookingData.currency;
			this.editRentalBookingForm.get('editJobRoomNo')?.setValue(bookingData.roomNo);
			this.editRentalBookingForm.get('editJobFlightNo')?.setValue(bookingData.flightNo);
			this.editRentalBookingForm.get('editRideSetDriverId')?.setValue(bookingData.driverId);
			this.editCarTypeRentArray = [{
				'carTypeId': bookingData.carTypeId,
				'carTypeName': bookingData.carTypeName,
			}];

			this.editJobDistanceVariant = bookingData.distanceVariant;
			this.editJobSurgeMultiplier = bookingData.surgeMultiplier;
			this.editJobZoneSurgePopup = 1;
			this.editJobZoneId = bookingData.zoneId;
			this.editRideArrears = (bookingData.arrears != undefined) ? bookingData.arrears : 0.00;
			let totalTax = this.Global.taxCalculate(+this.editJobCarRent);
			this.editRideTax = +totalTax.totalTaxAmount.toFixed(environment.roundUpNumber);
			this.editRideTotal = +(parseFloat(this.editJobCarRent.toString()) + totalTax.totalTaxAmount).toFixed(environment.roundUpNumber);
			if (!this.editPickupTime) {
				this.editPickupTime = bookingData.pickupTime
			}

			let getDayOrNight = this.Global.getDayNight(this.editPickupTime);
			let extraCharges = 0.00;
			if (getDayOrNight == "DAY") {
				extraCharges = this.editExtraCharges.extra_charges_day_price;
			} else if (getDayOrNight == "NIGHT") {
				extraCharges = this.editExtraCharges.extra_charges_night_price;
			}
			console.log("===== extraCharges Edit:: ", extraCharges);
			this.editExtraCharges = {
				bookingType: this.editExtraCharges.extra_charges_booking_type,
				chargeType: this.editExtraCharges.extra_charges_price_type,
				chargeData: extraCharges
			};

			this.editJobSelectedCarTypeData = {
				'data': {
					'baseFare': bookingData.baseFare,
					'carTypeId': bookingData.carTypeId,
					'carTypeName': bookingData.carTypeName,
					'extraCharges': this.editExtraCharges,
					'isCorporateCar': bookingData.carDetails.isCorporateCar //! vishesh  12-02-24
				}
			}

			this.editServiceCharges = bookingData.serviceCharges,
				this.editShowPassengerInfo = true;

			if (bookingData.userJson.length > 0) {
				this.editRentalBookingForm.get('id')?.setValue(bookingData.userJson[0].passengerId);
				this.editRentalBookingForm.get('accountId')?.setValue(bookingData.userJson[0].accountId ? bookingData.userJson[0].accountId : bookingData.accountId);
				this.editRentalBookingForm.get('name')?.setValue(bookingData.userJson[0].passengerName);
				this.editRentalBookingForm.get('phone')?.setValue(bookingData.userJson[0].passengerPhone.trim());
				this.editRentalBookingForm.get('emailAddress')?.setValue(bookingData.userJson[0].passengerEmail.trim());
				this.selectedPassengerId = bookingData.userJson[0].passengerId.trim();
				this.selectedAccountId = bookingData.userJson[0].accountId ? this.selectedAccountId = bookingData.userJson[0].accountId.trim() : this.selectedAccountId = '';
			}

			this.editRentalBookingForm.get('editJobUserComment')?.setValue(bookingData.userComment);
			this.editRentalBookingForm.get('editJobDriverComment')?.setValue(bookingData.driverComment);
			this.editRideBookingToDateTime = moment(bookingData.pickupTime, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");

			if (bookingData.bookingType == 0) {
				this.editRideOptionStatus = true;
			}
			else if (bookingData.bookingType == 1) {
				this.editRideOptionStatus = false;
				let time = moment(bookingData.pickupTime).format("HH:mm:ss").split(":");
				this.editRentalBookingForm.get('editRideSelectedHours')?.setValue(time[0]);
				this.editRentalBookingForm.get('editRideSelectedMinute')?.setValue(this.setMinutes(time[1]));
				this.editRideBookingToDate = moment(bookingData.pickupTime, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD");
				let editTime = moment(bookingData.pickupTime, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD");
				let getDiff = moment(bookingData.pickupTime).diff(moment(bookingData.assignTime), 'minutes')
				this.editRentalBookingForm.get('editBookingCalenderModel')?.setValue({ start: moment(editTime), end: moment(editTime) });
				this.editRentalBookingForm.get('editRideSelectedAssignTime')?.setValue("" + getDiff);
				console.log('---- selected editRideSelectedHours-----', this.editRentalBookingForm.value.editRideSelectedHours);
				console.log('---- selected editRideSelectedMinute-----', this.editRentalBookingForm.value.editRideSelectedMinute);
				this.setPickupTime();
			}
			this.clcBookingPrice();

			return true;
		}
		else {
			this.Popup.toasterMessage({
				'status': 'error',
				'title': "Oovvps!",
				'message': "Please pass required parameters for Rental booking.",
			});
			return false;
		}
	}


	cancelBookingConfirmCall(callType: string) {
		this.shareData.shareData({ function: 'cancelBookingConfirmCall', 'callType': callType, 'details': { carRent: this.editJobCarRent, editRideTotal: this.editRideTotal } })
	}

	editCarTypeId: string = ''
	editCarTypeName: string = ''
	isCorporateCarSelected: boolean = false
	carSelected: any = null;
	selectAccountCar(car: any) {
		console.log('****** selectAccountCar car ******', car);
		console.log('****** packages array car ******', this.packagesArray);
		console.log('****** editRentalPackage ******', this.editRentalPackage);
		const selected = this.packagesArray.find((data: any) => data.packageId == this.editRentalPackage);
		this.selectedPackageInfo = selected
			? { packageDisableOtherCharge: selected.packageDisableOtherCharge, packageHours: selected.packageHours, packageKm: selected.packageKm }
			: null;
		console.log('--------------------- this.selectedPackageInfo ---------------------', this.selectedPackageInfo)

		this.carSelected = car;
		this.isCorporateCarSelected = true;
		this.withoutSurgeEditJobCarRent = this.carSelected.carRent;
		this.Global.isRentalSubmit = false
		this.editJobSelectedCarTypeData.data = { carTypeId: this.carSelected.rentalCarCarTypeId, baseFare: this.carSelected.baseFare, extraCharges: { bookingType: this.editRideOptionStatus == true ? 0 : 1 } };

		this.clcBookingPrice();
		this.editCarTypeId = this.carSelected.rentalCarCarTypeId;
		this.editCarTypeName = this.carSelected.carType
		console.log('++++++++++++++++++++', this.carSelected);
		this.selectedCarDetails = {
			"rentalCarPerKMDayRate": this.carSelected.rentalCarPerKMDayRate,
			"rentalCarPerMinDayRate": this.carSelected.rentalCarPerMinDayRate,
			"rentalCarPerKMNightRate": this.carSelected.rentalCarPerKMNightRate,
			"rentalCarPerMinNightRate": this.carSelected.rentalCarPerMinNightRate,
			"rentalCarDayCancellationFare": this.carSelected.rentalCarDayCancellationFare,
			"rentalCarNightCancellationFare": this.carSelected.rentalCarNightCancellationFare,
			"rentalCarDayBaseFare": this.carSelected.rentalCarDayBaseFare,
			"rentalCarNightBaseFare": this.carSelected.rentalCarNightBaseFare,
			"carSeatCapacity": this.carSelected.carSeatCapacity,
			"carDayWaitPrice": this.carSelected.carDayWaitPrice,
			"carNightWaitPrice": this.carSelected.carNightWaitPrice,
			"carMultiplierDay": this.carSelected.carMultiplierDay,
			"carMultiplierNight": this.carSelected.carMultiplierNight,
			"isCorporateCar": this.carSelected.isCorporateCar,
			"packagesInfo": this.selectedPackageInfo
		}
		// this.editRentalBooking()
	}

	onCancelClick() {
		this.isAccountUser = false;
		this.isCorporateCarSelected = false
		this.selectAccountCar(this.editCarTypeRentArray[0]);
	}

	editRentalBookingCall() {
		if (this.isCorporateCarSelected) {
			this.editRentalBooking()
		}
		else {
			this.selectAccountCar(this.editCarTypeRentArray[0]);
			this.editRentalBooking()
		}
	}

	setDragMarkerLocation($event: any, locations: any) {
		if (!this.isActiveBooking) {
			this.editRentalBookingForm.get('pickupPoint')?.setValue(locations.address);
			this.editLocationList[0].address = locations.address;
			this.editLocationList[0].lat = $event.coords.lat;
			this.editLocationList[0].long = $event.coords.lng;

			let requestObj = {
				lat: Number($event.coords.lat),
				long: Number($event.coords.lng),
				address: locations.address,
			};

			this.CallMethod.getRentalPackage(requestObj).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
				if (result.status) {
					console.log('data get from get rental packages', result)
					this.packagesArray = result.packagesInfo;
					result.zoneId ? this.editJobZoneId = result.zoneId : null
					this.Global.isRentalSubmit = false
					this.packageHours = this.packagesArray[0].packageHours;
					console.log('****** resetBooking Price calling ******');
					this.resetBookingPrice(this.packagesArray[0].packageId)
				}

				else if (!result.status) {
					this.Popup.toasterMessage({
						'status': 'error',
						'title': "OOpps!",
						'message': "Rental Service is not available in this area.",
					});
					this.Global.isRentalSubmit = true
				}
			});
		}
	}

	selectedBooking: any = {};
	/* Edit Booking Objects */
	editRentalPackage: any;
	editJobCarRent: number = 0;
	withoutSurgeEditJobCarRent: number = 0;
	editJobDiscountAmount: number = 0.00;
	editCarTypeRentArray: any = [];
	editLocationJson: any[] = [];
	editJobCurrency: any = null;
	editJobDistanceVariant: number = 1;
	editJobSurgeMultiplier: number = 1;
	editJobZoneSurgePopup: number = 1;
	editJobZoneId: string = "";
	editJobShowRentInfo: boolean = false;
	editShowPassengerInfo: boolean = false;
	editNewRideSelectCarTypeDisable: boolean = true;

	newRideTax: number = 0;
	editRideTax: number = 0;
	editRideArrears: number = 0.00;
	newRideTotal: any = 0;
	editRideTotal: number = 0;
	selectedCarTypeData: any = {};
	editJobSelectedCarTypeData: any = {};

	editJobCarTypeArray: any = { "DAY": [], "NIGHT": [] };
	showRentShimmer: boolean = true;

	/* Edit Booking object */
	editRideOptionStatus: boolean = true;
	editPickupTime: any = null;
	editRideBookingToDate: any = null;
	editRideBookingToDateTime: any = null;
	setEditMinDate: any = null;
	serviceCharges: number = 0.000;
	isPriceFromAirportZone: number = 0;
	editServiceCharges: number = 0.000;
	editIsPriceFromAirportZone: number = 0;
	editJobLoader: Boolean = true;
	clearEditBooking() {
		this.editRentalBookingForm.reset();
		this.editLocationList = [];
		this.editLocationJson = [];
		this.shareData.shareData({ function: 'SetRentalLocationInMap', 'data': this.editLocationList })
		this.editJobCarRent = 0;
		this.editJobCurrency = "";
		this.editCarTypeRentArray = [];
		this.editJobDistanceVariant = 1;
		this.editJobSurgeMultiplier = 1;
		this.editJobZoneSurgePopup = 1;
		this.editJobZoneId = "";
		this.editJobCarTypeArray = { "DAY": [], "NIGHT": [] };
		this.withoutSurgeEditJobCarRent = 0;
		this.editRideTax = 0;
		this.editJobDiscountAmount = 0;
		this.editRideTotal = 0;
		this.editJobSelectedCarTypeData = {};
		this.setEditMinDate = null;
		this.editRideBookingToDate = null;
		this.editRideBookingToDateTime = null;
		this.editRideOptionStatus = true;
		this.editPickupTime = null;
		this.editJobAccountDataList = [];
		this.editRideSetDriverId = (this.Global.appMode == 1) ? 'automatic' : 'manual';
		this.editJobShowRentInfo = false;
		this.editShowPassengerInfo = false;
		this.editNewRideSelectCarTypeDisable = true;
		this.editJobLoader = true;
		this.selectedPaymentType = 0;
		this.editIsPriceFromAirportZone = 0;
		this.editServiceCharges = 0.000;
	}

	editErrorPopup: any = {
		isShow: false,
		type: 'error',
		msg: ''
	};

	flag: string = "";
	checkCreatebookingValidation: boolean = true;
	public searchAutoComplete = new Subject<KeyboardEvent>();
	@ViewChild('createbookingArea') createbookingArea!: ElementRef;
	autoCompleteSearch1(event: any, focus: string = '', inputType: string = '') {
		if (event.target.value && event.target.value.trim() != '' && focus != 'focusOut') {
			console.log('--------------------- searching ---------------------', event)
			this.searchAutoComplete.next(event);
		}
		else {
			if (focus == 'focusOut' && this.checkCreatebookingValidation) {
				let locationIndex = this.locationList.findIndex(obj => obj.addressId === inputType);
				let isValid = false;
				if (locationIndex >= 0) {

					if (this.locationList[locationIndex].address == event.target.value) {
						isValid = true;
					}
				}
				if (event.target.value.trim() == '' || isValid == false) {
					// setTimeout(() => {
					//   let inputFocus = document.getElementById(event.target.id) as HTMLInputElement;
					//   inputFocus.focus();
					// }, 0);
				}
			}
		}
	}

	isOpenCreateEditdraftjob: number = 1
	locationList: any[] = [];
	editLocationList: any[] = [];
	autoCompleteEnterText(events: any, selectedLocations: any, inputType: string) {
		if (events.isUserInput === false) {
			return;
		}

		if (selectedLocations.lat == 0 && selectedLocations.long == 0 && selectedLocations.placeId != '') {
			this.Global.sessionId = "";
			this.flag = "";

			this.CallMethod.setAutoCompleteAddress({
				"sessionId": this.Global.getSessionId(),
				"address": selectedLocations.title + " " + selectedLocations.address,
				"title": selectedLocations.title,
				"placeId": selectedLocations.placeId,
			}).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
				selectedLocations.lat = result.lat;
				selectedLocations.long = result.long;
				this.pushLocationData(inputType, selectedLocations);
			});
		}
		else {
			this.pushLocationData(inputType, selectedLocations);
		}

		let requestObj = {
			lat: Number(selectedLocations.lat),
			long: Number(selectedLocations.long),
			address: selectedLocations.address,
		};

		this.CallMethod.getRentalPackage(requestObj).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
			if (result.status == true) {
				this.packagesArray = result.packagesInfo;
				result.zoneId ? this.editJobZoneId = result.zoneId : null
				this.Global.isRentalSubmit = false
				this.packageHours = this.packagesArray[0].packageHours;
				console.log('****** resetBooking Price calling ******');
				this.resetBookingPrice(this.packagesArray[0].packageId)
			}
			else if (result.status == false) {
				this.Popup.toasterMessage({
					'status': 'error',
					'title': "OOpps!",
					'message': "Rental Service is not available in this area.",
				});
				this.Global.isRentalSubmit = true
			}
		});
	}

	newEstimatedExtraCharges: any = 0.00;
	editEstimatedExtraCharges: any = 0.00;
	newRideBookingFromDate: any = null;
	repeatedDateArray: any = null;
	newRide_repeatStatus: boolean = false;
	setMinDate: any = null;
	minDate: any;
	newJobWhenRide(when: string) {
		let companyTime = this.Global.getCompanyCurrentTime();
		if (when === "now") {
			this.editRideOptionStatus = true;
			this.editPickupTime = moment(companyTime, this.Global.dateFormat).format("YYYY-MM-DD HH:mm:ss");
			// Added afterwards
			this.editRideBookingToDate = moment(companyTime, this.Global.dateFormat).format("YYYY-MM-DD"); //date
			this.editRideBookingToDateTime = moment(companyTime, this.Global.dateFormat).format("YYYY-MM-DD HH:mm:ss"); //date
			this.editRentalBookingForm.value.editRideSelectedHours = moment(this.Global.getCompanyCurrentTime(), this.Global.dateFormat).format('HH');
			this.editRentalBookingForm.value.editRideSelectedMinute = moment(this.Global.getCompanyCurrentTime(), this.Global.dateFormat).format('mm');
		}

		else if (when === "later") {
			this.setAssignMinutes();
			this.editRideOptionStatus = false;
			let futureDate = moment(companyTime, this.Global.dateFormat).add(15, 'minutes');
			let time = moment(futureDate).format("HH:mm:ss").split(":");
			this.editRentalBookingForm.get('editRideSelectedHours')?.setValue(time[0]);
			this.editRentalBookingForm.get('editRideSelectedMinute')?.setValue(this.setMinutes(time[1]));
			this.editRideBookingToDate = moment(companyTime, this.Global.dateFormat).format("YYYY-MM-DD"); //date
			this.editRideBookingToDateTime = moment(companyTime, this.Global.dateFormat).format("YYYY-MM-DD HH:mm:ss"); //date
			let minDate = moment(companyTime, this.Global.dateFormat).format("YYYY-MM-DD");
			this.setEditMinDate = moment(minDate);
			this.editRentalBookingForm.get('editBookingCalenderModel')?.setValue({ start: moment(companyTime, this.Global.dateFormat), end: moment(companyTime, this.Global.dateFormat) });

		}
		this.setPickupTime();
		this.resetBookingPrice(this.editRentalPackage);

	}

	newRideBookingToDate: any = null;
	pickupTime: any = null;
	setPickupTime() {
		let companyTime = this.Global.getCompanyCurrentTime();
		let selectbooktime = moment(this.editRideBookingToDate).format("YYYY-MM-DD") + " " + this.editRentalBookingForm.value.editRideSelectedHours
			+ ":" + this.editRentalBookingForm.value.editRideSelectedMinute;
		this.editPickupTime = moment(selectbooktime).format("YYYY-MM-DD HH:mm:ss");
	}

	setFixPrice(time: any, carTypeId: string = 'default') {
		this.Global.carTypeId = ""
		if (this.editNewRideSelectCarTypeDisable == false) {
			const dayNight: string = this.Global.getDayNight(time);
			this.editCarTypeRentArray = this.editJobCarTypeArray[dayNight];
		}
	}

	newRideLaterHoursChange(event: any) {
		this.editRentalBookingForm.value.editRideSelectedHours = event.target.value;
		this.setPickupTime();
		console.log('****** resetBooking Price calling ******');
		this.resetBookingPrice(this.editRentalPackage);
	}


	selectedPackageInfo: any
	newRidePackageChange(event: any) {
		let req: any = {
			"packageId": event.target.value,
			// "carTypeId": this.editCarTypeRentArray[0].carTypeId,
			"userId": this.selectedPassengerId
		}

		console.log('******* Going to call getRentalCarsPackage ******')
		this.CallMethod.getRentalPackageCars(req).subscribe((result: any) => {
			if (!result.status && result.statusCode == 1) {
				console.log('****** result from select package *******', result)
				this.Popup.toasterMessage({
					'status': 'error',
					'title': 'incorrect package',
					'message': 'This package is not available for current carType.',
				});
				this.Global.isRentalSubmit = true
			}

			else if (!result.status && result.statusCode == 10) {
				console.log('****** result from select package *******', result)
				this.Popup.toasterMessage({
					'status': 'error',
					'title': 'incorrect package',
					'message': 'This package is not available for current corporate carType.',
				});
				this.Global.isRentalSubmit = true

			}
			else if (result.status) {
				const dayNight: string = this.Global.getDayNight(this.editPickupTime);
				console.log('this.editPickupTime', this.editPickupTime);
				console.log('dayNight', dayNight);
				console.log("========== setFixPrice edit dayNight :: ", dayNight);
				const index = result.rentalCars.findIndex((data: any) => data.rentalCarCarTypeId == this.editCarTypeId);
				console.log('this.editCarTypeId', this.editCarTypeId)
				console.log('index', index)
				if (index >= 0) {
					this.editJobCarTypeArray["DAY"] = result.rentalCars[index].rentalCarDayBaseFare;
					this.editJobCarTypeArray["NIGHT"] = result.rentalCars[index].rentalCarNightBaseFare;
					this.withoutSurgeEditJobCarRent = this.editJobCarTypeArray[dayNight];
					this.Global.isRentalSubmit = false;
					console.log('this.Global.isRentalSubmit', this.Global.isRentalSubmit)
					this.clcBookingPrice();
				}
				else {
					console.log('___++++___', result)
					this.editCarTypeRentArray = []
					this.isAccountUser = true;
					const dayNight: string = this.Global.getDayNight(this.editPickupTime);
					for (let i = 0; i < result.rentalCars.length; i++) {
						this.editJobCarTypeArray["DAY"] = result.rentalCars[i].rentalCarDayBaseFare;
						this.editJobCarTypeArray["NIGHT"] = result.rentalCars[i].rentalCarNightBaseFare;
						result.rentalCars[i].carRent = this.editJobCarTypeArray[dayNight];
						result.rentalCars[i].baseFare = this.editJobCarTypeArray[dayNight];
						this.editCarTypeRentArray[i] = result.rentalCars[i];
					}
					console.log('^^^^^^^^^^^^', this.editCarTypeRentArray);
					console.log('^^^^^^^^^ selectedpackageinfo', this.selectedPackageInfo)
					this.shareData.shareData({ 'function': 'OpenCarTypeSelectionModel', 'data': this.editCarTypeRentArray });
					this.showRentShimmer = true;
				}
				// this.editRideTotal = this.editJobCarTypeArray[dayNight];
			}
		});
		this.editRentalPackage = event.target.value;
		const selected = this.packagesArray.find((data: any) => data.packageId == event.target.value);
		this.selectedPackageInfo = selected
			? { packageDisableOtherCharge: selected.packageDisableOtherCharge, packageHours: selected.packageHours, packageKm: selected.packageKm }
			: null;



		console.log('---- selected packageinfo -----', this.selectedPackageInfo)
	}

	resetBookingPrice(packageId: string) {
		let req: any = {
			"packageId": packageId,
			// "carTypeId": this.editCarTypeRentArray[0].carTypeId,
			"userId": this.selectedPassengerId
		}

		console.log('******* Going to call getRentalCarsPackage ******')
		this.CallMethod.getRentalPackageCars(req).subscribe((result: any) => {
			if (!result.status && result.statusCode == 1) {
				console.log('****** result from select package *******', result)
				this.Popup.toasterMessage({
					'status': 'error',
					'title': 'incorrect package',
					'message': 'This package is not available for current carType.',
				});
				this.Global.isRentalSubmit = true

			}

			else if (!result.status && result.statusCode == 10) {
				console.log('****** result from select package *******', result)
				this.Popup.toasterMessage({
					'status': 'error',
					'title': 'incorrect package',
					'message': 'This package is not available for current corporate carType.',
				});
				this.Global.isRentalSubmit = true

			}
			else if (result.status) {
				const dayNight: string = this.Global.getDayNight(this.editPickupTime);
				console.log("========== setFixPrice edit dayNight 1012 :: ", dayNight);
				const index = result.rentalCars.findIndex((data: any) => data.rentalCarCarTypeId == this.editCarTypeId);
				this.editJobCarTypeArray["DAY"] = result.rentalCars[index].rentalCarDayBaseFare;
				this.editJobCarTypeArray["NIGHT"] = result.rentalCars[index].rentalCarNightBaseFare;
				this.withoutSurgeEditJobCarRent = this.editJobCarTypeArray[dayNight];
				console.log('********______********', this.withoutSurgeEditJobCarRent)
				this.Global.isRentalSubmit = false
				this.clcBookingPrice();
			}
		});
		this.editRentalPackage = packageId;
		console.log('packages array from 1043', this.packagesArray);
		const selected = this.packagesArray.find((data: any) => data.packageId == packageId);
		this.selectedPackageInfo = selected
			? { packageDisableOtherCharge: selected.packageDisableOtherCharge, packageHours: selected.packageHours, packageKm: selected.packageKm }
			: null;

		console.log('---- selected packagesinfo -----', this.selectedPackageInfo)
	}



	newRideLaterMinuteChange(event: any) {
		this.editRentalBookingForm.value.editRideSelectedMinute = event.target.value;
		this.setPickupTime();
		console.log('****** resetBooking Price calling ******');
		this.resetBookingPrice(this.editRentalPackage);
	}

	newRideDateChange(event: any) {
		if (event.endDate != null) {
			this.editRideBookingToDate = moment(event.endDate).format("YYYY-MM-DD");
			this.editRideBookingToDateTime = moment(event.endDate).format("YYYY-MM-DD HH:mm:ss");
		}
		this.setPickupTime()
	}

	setMinutes(value: any) {
		let minuteValue = parseInt(value);
		let minutes: string = "";
		if (minuteValue > 55) {
			minutes = "55";
		} else if (minuteValue > 50 && minuteValue <= 55) {
			minutes = "55";
		} else if (minuteValue > 45 && minuteValue <= 50) {
			minutes = "50";
		} else if (minuteValue > 40 && minuteValue <= 45) {
			minutes = "45";
		} else if (minuteValue > 35 && minuteValue <= 40) {
			minutes = "40";
		} else if (minuteValue > 30 && minuteValue <= 35) {
			minutes = "35";
		} else if (minuteValue > 25 && minuteValue <= 30) {
			minutes = "30";
		} else if (minuteValue > 20 && minuteValue <= 25) {
			minutes = "25";
		} else if (minuteValue > 15 && minuteValue <= 20) {
			minutes = "20";
		} else if (minuteValue > 10 && minuteValue <= 15) {
			minutes = "15";
		} else if (minuteValue > 5 && minuteValue <= 10) {
			minutes = "10";
		} else if (minuteValue > 0 && minuteValue <= 5) {
			minutes = "05";
		} else {
			minutes = "00";
		}
		return minutes;
	}

	hoursArray: any[] = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"];
	minutesArray: any[] = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];
	newRideSelectedHours: string = "00";
	newRideSelectedMinute: string = "15";
	newRideSelectedAssignTime: string = "15";
	setAssignMinutes() {
		let lat;
		let lng;

		lat = this.editLocationList[0].lat;
		lng = this.editLocationList[0].long;

		let duration: any = this.Global.getDuration([{
			"lat": lat,
			"lng": lng
		}]);

		let min: string = "";
		if (duration >= 0 && duration <= 5) {
			min = "5";
		} else if (duration > 5 && duration <= 10) {
			min = "10";
		} else if (duration > 10 && duration <= 15) {
			min = "15";
		} else if (duration > 15 && duration <= 20) {
			min = "20";
		} else if (duration > 20 && duration <= 30) {
			min = "30";
		} else if (duration > 30 && duration <= 45) {
			min = "45";
		} else if (duration > 45 && duration <= 60) {
			min = "60";
		} else if (duration > 60 && duration <= 75) {
			min = "75";
		} else if (duration > 75 && duration <= 90) {
			min = "90";
		} else if (duration > 90 && duration <= 120) {
			min = "120";
		} else if (duration > 120 && duration <= 150) {
			min = "150";
		} else if (duration > 150 && duration <= 180) {
			min = "180";
		} else if (duration > 180 && duration <= 210) {
			min = "210";
		} else if (duration > 210 && duration <= 240) {
			min = "240";
		} else if (duration > 240 && duration <= 270) {
			min = "270";
		} else {
			min = "300";
		}
		if (this.Global.minimumAssignMinutes > parseInt(min)) {
			min = "" + this.Global.minimumAssignMinutes;
		}
		// this.editRentalBookingForm.value.editRideSelectedAssignTime = min;
		this.editRentalBookingForm.get('editRideSelectedAssignTime')?.setValue(min);
	}

	pushLocationData(inputType: string, selectedLocations: any) {
		let address = {
			'address': selectedLocations.title + ", " + selectedLocations.address,
			'title': selectedLocations.title,
			'lat': selectedLocations.lat,
			'long': selectedLocations.long,
			'addressId': inputType,
		}

		this.editLocationList[0] = address;
		if (this.editRideOptionStatus == false) {
			this.setAssignMinutes();
		}
		this.shareData.shareData({ function: 'SetRentalLocationInMap', 'data': this.editLocationList })
	}

	// start passenger list
	public searchCorporateAccount = new Subject<KeyboardEvent>();
	newRideforPassenger(event: any) {
		if (event.target.value.trim() != '') {
			this.searchCorporateAccount.next(event);
		}
	}

	accountDetails(userDetails: any) {
		console.log('accountDetails change value', userDetails);
		console.log('selected AccountId', this.selectedAccountId)
		if (this.selectedAccountId && this.selectedAccountId.length > 0) {
			if (userDetails.userAccountId != this.selectedAccountId) {
				this.selectedPassengerId = userDetails.userId;

				let req = {
					"userId": userDetails.userId,
					"packageId": this.editRentalPackage,
				}

				console.log('******* Going to call getRentalCarsPackage ******')
				this.CallMethod.getRentalPackageCars(req).subscribe((result: any) => {
					this.showRentShimmer = false;
					if (!result.status && result.statusCode == 1) {
						console.log('****** result from select package *******', result)
						this.Popup.toasterMessage({
							'status': 'error',
							'title': 'incorrect package',
							'message': 'This package is not available for current carType.',
						});
						this.Global.isRentalSubmit = true
					}
					else if (result.status) {
						console.log('___++++___', result)
						this.editCarTypeRentArray = []
						this.isAccountUser = true;
						const dayNight: string = this.Global.getDayNight(this.editPickupTime);
						for (let i = 0; i < result.rentalCars.length; i++) {
							this.editJobCarTypeArray["DAY"] = result.rentalCars[i].rentalCarDayBaseFare;
							this.editJobCarTypeArray["NIGHT"] = result.rentalCars[i].rentalCarNightBaseFare;
							result.rentalCars[i].carRent = this.editJobCarTypeArray[dayNight];
							result.rentalCars[i].baseFare = this.editJobCarTypeArray[dayNight];
							this.editCarTypeRentArray[i] = result.rentalCars[i];
						}
						console.log('^^^^^^^^^^^^', this.editCarTypeRentArray);
						console.log('^^^^^^^^^ selectedpackageinfo', this.selectedPackageInfo)
						this.shareData.shareData({ 'function': 'OpenCarTypeSelectionModel', 'data': this.editCarTypeRentArray });
						this.showRentShimmer = true;
					}
				});
				this.selectedAccountId = userDetails.userAccountId
			}

		}
		if (userDetails !== null && userDetails !== undefined) {
			this.editRentalBookingForm.patchValue({
				accountId: userDetails.userAccountId,
				id: userDetails.userId
			});
			this.selectedPassengerId = userDetails.userId;
			this.selectedAccountId = userDetails.userAccountId

		}
	}

	setUserIndex: number = 0;
	editJobSetUserIndex: number = 0;
	searchCustomer(index: number, formFieldName: string) {
		console.log('calling search customer function')
		this.Global.openCustomersPopup = 'home';
		var form: any = new FormGroup({});

		form = this.editRentalBookingForm;
		this.editJobSetUserIndex = index;

		if (formFieldName != '') {
			setTimeout(() => {
				this.shareData.shareData({ function: 'customerDetailPopup', 'searchValue': form.value.formFieldName })
			}, 50);
		}
	}

	newRideSetDriverId: string = (this.Global.appMode == 1) ? 'automatic' : 'manual';
	editRideSetDriverId: string = (this.Global.appMode == 1) ? 'automatic' : 'manual';
	driverAssignTo(event: any) {
		this.editRideSetDriverId = event.target.value;
	}

	couponDataList: any[] = [];
	editJobCouponDataList: any[] = [];
	couponDisplayDataList: any[] = [];
	editJobCouponDisplayDataList: any[] = [];
	// ! needs to update
	getCoupon(event: any, type: string) {
		if ((type == 'click' && event.target.value != 'undefined' && event.target.value.trim() != '') || type != 'click' && event.target.value != 'undefined' && event.target.value.trim() != '') {
			this.searchCoupon(event.target.value);
		}
		else {
			this.getCouponCall();
		}
	}

	couponLoader: boolean = true;
	getCouponCall() {
		let req: any = {
			bookingFlag: 0
		}

		if (this.editJobSelectedCarTypeData && this.editJobSelectedCarTypeData.data && Object.entries(this.editJobSelectedCarTypeData).length !== 0 && Object.entries(this.editJobSelectedCarTypeData.data).length !== 0 && this.editJobSelectedCarTypeData.data.carTypeId != '') {
			req.carTypeId = this.editJobSelectedCarTypeData.data.carTypeId;
		}

		if (this.editRentalBookingForm.value.id.trim() != '') {
			req['userId'] = this.editRentalBookingForm.value.id;
		}

		this.editJobCouponLoader = false;

		this.CallMethod.getCoupon(req).subscribe((result: any) => {
			this.editJobCouponLoader = true;
			if (result.status) {
				this.editJobCouponDataList = [];
				if (result.couponData.length > 0) {
					for (let i = 0; i < result.couponData.length; i++) {
						if (this.isOpenCreateEditdraftjob == 1) {
							this.editJobCouponDataList.push({
								couponId: result.couponData[i].couponId,
								couponCode: result.couponData[i].couponCode,
								couponDiscount: result.couponData[i].couponDiscount,
								couponDiscountType: result.couponData[i].couponDiscountType,
								couponMaxDiscount: result.couponData[i].couponMaxDiscount,
								couponTitle: result.couponData[i].couponTitle,
								couponUserId: result.couponData[i].couponUserId,
								isLocationSpecific: result.couponData[i].isLocationSpecific,
							});

						}
					}


					if (Object.entries(this.editRentalBookingForm.value.editBookingCouponCode).length !== 0) {
						let index = this.editJobCouponDataList.findIndex(((obj: any) => obj.couponCode == this.editRentalBookingForm.value.editBookingCouponCode.couponCode));
						if (index < 0) {
							this.editRentalBookingForm.value.editBookingCouponCode = {};
						}
					}
				}
				this.editJobCouponDisplayDataList = this.editJobCouponDataList;
			}
		});
	}

	// @ViewChild("editBookingCouponCode") editBookingCouponCode!: ElementRef;
	searchCoupon(value: string) {
		this.editJobCouponDisplayDataList = this.Global.filterByValueObj(this.editJobCouponDataList, "couponCode", value);
	}

	carRent: number = 0;
	discountAmount: number = 0.00;
	clcBookingPrice() {
		this.editJobCarRent = this.withoutSurgeEditJobCarRent * this.editJobSurgeMultiplier;
		this.editJobCarRent = parseFloat(this.editJobCarRent.toFixed(environment.priceRoundUpNumber));
		this.editJobDiscountAmount = 0;

		if (Object.entries(this.editRentalBookingForm.value.editBookingCouponCode).length !== 0) {
			this.editJobDiscountAmount = this.clcDiscount(this.editRentalBookingForm.value.editBookingCouponCode, this.editJobCarRent);
		}

		let beforeDiscount = this.editJobCarRent - this.editJobDiscountAmount;

		// Extra Charges
		this.dispatcherFeesCalculate((this.editRideOptionStatus == true) ? 'now' : 'later', beforeDiscount);
		let totalTax = this.Global.taxCalculate(beforeDiscount, this.selectedBooking.taxJson);
		this.editRideTax = parseFloat(totalTax.totalTaxAmount.toFixed(environment.priceRoundUpNumber));
		this.editRideTotal = parseFloat((beforeDiscount + totalTax.totalTaxAmount + this.editRideArrears + this.editEstimatedExtraCharges + this.editServiceCharges).toFixed(environment.priceRoundUpNumber));
	}

	dispatcherFeesCalculate(bookingType: any, amount: any) {
		this.editEstimatedExtraCharges = 0;

		if (this.editRideOptionStatus == true && (this.editJobSelectedCarTypeData.data.extraCharges.bookingType == 0 || this.editJobSelectedCarTypeData.data.extraCharges.bookingType == 2)) {
			if (this.editJobSelectedCarTypeData.data.extraCharges.chargeType == 0) {

				this.editEstimatedExtraCharges = (amount * this.editJobSelectedCarTypeData.data.extraCharges.chargeData) / 100;
			} else if (this.editJobSelectedCarTypeData.data.extraCharges.chargeType == 1) {
				this.editEstimatedExtraCharges = this.editJobSelectedCarTypeData.data.extraCharges.chargeData;
			}
		} else if (this.editRideOptionStatus == false && (this.editJobSelectedCarTypeData.data.extraCharges.bookingType == 1 || this.editJobSelectedCarTypeData.data.extraCharges.bookingType == 2)) {
			if (this.editJobSelectedCarTypeData.data.extraCharges.chargeType == 0) {
				this.editEstimatedExtraCharges = (amount * this.editJobSelectedCarTypeData.data.extraCharges.chargeData) / 100;
			} else if (this.editJobSelectedCarTypeData.data.extraCharges.chargeType == 1) {
				this.editEstimatedExtraCharges = this.editJobSelectedCarTypeData.data.extraCharges.chargeData;
			}
		}
	}

	clcDiscount(couponData: any, amount: number) {
		let discountAmount = 0.00;
		console.log(typeof couponData.couponCodeAmount)
		if (Object.entries(couponData).length !== 0) {
			if (couponData.couponCodeType == 1) {
				let discount = (amount * couponData.couponCodeAmount) / 100;
				discountAmount = (discount > couponData.couponCodeMaxAmount) ? couponData.couponCodeMaxAmount : discount;
			} else {
				discountAmount = couponData.couponCodeAmount;
				discountAmount = (amount <= couponData.couponCodeAmount) ? amount : couponData.couponCodeAmount;
			}
		}
		return discountAmount;
	}

	selectedCoupon: any = {};
	removeCouponCode() {
		this.editRentalBookingForm.value.editBookingCouponCode = {};
		this.clcBookingPrice();
	}

	selectCoupon(data: any, callType: string = '') {
		console.log('select coupon from options', data)
		this.editRentalBookingForm.value.editBookingCouponCode = {
			couponCode: data.couponCode,
			couponCodeAmount: data.couponDiscount,
			couponCodeMaxAmount: data.couponMaxDiscount,
			couponCodeType: data.couponDiscountType,
			couponId: data.couponId,
			couponTitle: data.couponTitle,
			couponUserId: data.couponUserId,
			isLocationSpecific: data.isLocationSpecific
		};
		if (callType == 'carTypeChange') {
			this.editJobCouponDisplayDataList = [];
			this.editJobCouponDataList = [];
			this.editJobCouponDisplayDataList.push(data);
			this.editJobCouponDataList.push(data);
		}
		else {
			this.clcBookingPrice();
		}
	}
	createErrorPopup: any = {
		isShow: false,
		type: 'error',
		msg: ''
	};
}
